const PRODUCTION_STYTCH_PUBLIC_TOKEN = 'public-token-live-db5dfb0e-6423-4166-8366-164f4138e0ff';
const PRODUCTION_POSTHOG_PUBLIC_KEY = 'phc_s3lQIILexwlGHvxrMBqti355xUgkRocjMXW4LjV0ATw';

function normalizeOrigin(value: string): string {
  const url = new URL(value);
  if (value !== url.origin) {
    throw new Error('VITE_COLLAB_API_BASE_URL must be a bare origin');
  }
  return url.origin;
}

function websocketOrigin(value: string): string {
  const url = new URL(value);
  url.protocol = url.protocol === 'https:' ? 'wss:' : 'ws:';
  return url.origin;
}

const collabApiBaseUrl = normalizeOrigin(
  import.meta.env.VITE_COLLAB_API_BASE_URL || (
    import.meta.env.MODE === 'development' ? 'http://localhost:8790' : 'https://sync.nimbalyst.com'
  ),
);

export const consoleConfig = {
  stytchPublicToken: import.meta.env.VITE_STYTCH_PUBLIC_TOKEN || PRODUCTION_STYTCH_PUBLIC_TOKEN,
  posthogPublicKey: import.meta.env.VITE_POSTHOG_PUBLIC_KEY || PRODUCTION_POSTHOG_PUBLIC_KEY,
  collabApiBaseUrl,
  collabWebSocketBaseUrl: websocketOrigin(collabApiBaseUrl),
  sessionDurationMinutes: 60 * 24 * 7,
} as const;

export const webAuthCallbackUrl = `${consoleConfig.collabApiBaseUrl}/auth/web/callback`;
